<template>
    <div class="builder-options-type-1 form-type-2">
        <OptionsExtra v-model="dataset.extra" :defaultVal="defaultDataset.extra" @update:modelValue="onChanged" cssClass="toggle-type-2" />
        <OptionsText v-model="dataset.text" :defaultVal="defaultDataset.text" @update:modelValue="onChanged" cssClass="toggle-type-2" />
        <OptionsSbi v-model="dataset.sbi" :defaultVal="defaultDataset.sbi" @update:modelValue="onChanged" cssClass="toggle-type-2" />
        <OptionsCompanySize v-model="dataset.company_size" :defaultVal="defaultDataset.company_size" @update:modelValue="onChanged" cssClass="toggle-type-2" />
        <OptionsLocation v-model="dataset.location" :defaultVal="defaultDataset.location" @update:modelValue="onChanged" cssClass="toggle-type-2" />
        <OptionsFounded v-model="dataset.founded" :defaultVal="defaultDataset.founded" @update:modelValue="onChanged" cssClass="toggle-type-2" />
        <OptionsOrgType v-model="dataset.orgtype" :defaultVal="defaultDataset.orgtype" @update:modelValue="onChanged" cssClass="toggle-type-2" />
        <OptionsSocials v-model="dataset.socials" :defaultVal="defaultDataset.socials" @update:modelValue="onChanged" cssClass="toggle-type-2" />
        <OptionsApps v-model="dataset.apps" :defaultVal="defaultDataset.apps" @update:modelValue="onChanged" cssClass="toggle-type-2" />
        <OptionsRelations v-model="dataset.relations" :defaultVal="defaultDataset.relations" @update:modelValue="onChanged" cssClass="toggle-type-2" />
        <OptionsBag v-model="dataset.bag" :defaultVal="defaultDataset.bag" @update:modelValue="onChanged" cssClass="toggle-type-2" />
    </div>
</template>

<script>
    import { mapState, mapActions } from 'pinia';
    import { useDatasetStore } from '@/stores/dataset';
    import OptionsFounded from '@/components/builder/builder/OptionsFounded';
    import OptionsLocation from '@/components/builder/builder/OptionsLocation';
    import OptionsApps from '@/components/builder/builder/OptionsApps';
    import OptionsOrgType from '@/components/builder/builder/OptionsOrgType';
    import OptionsSocials from '@/components/builder/builder/OptionsSocials';
    import OptionsRelations from '@/components/builder/builder/OptionsRelations';
    import OptionsText from '@/components/builder/builder/OptionsText';
    import OptionsSbi from '@/components/builder/builder/OptionsSbi';
    import OptionsExtra from '@/components/builder/builder/OptionsExtra';
    import OptionsBag from '@/components/builder/builder/OptionsBag';
    import OptionsCompanySize from '@/components/builder/builder/OptionsCompanySize';

    export default {
        name: 'BuilderOptions',
        components: {
            OptionsLocation,
            OptionsApps,
            OptionsFounded,
            OptionsOrgType,
            OptionsSocials,
            OptionsRelations,
            OptionsText,
            OptionsSbi,
            OptionsExtra,
            OptionsBag,
            OptionsCompanySize
        },
        computed: {
            ...mapState(useDatasetStore, ['dataset', 'defaultDataset', 'query']),
        },
        methods: {
            ...mapActions(useDatasetStore, ['updateDataset']),
            onChanged() {
                this.updateDataset();
            }
        }
    }
</script>